import browserRedirect from '@/utils/isPc'
import Vue from "vue";
import Router from "vue-router";
import pcIndex from "@/views/index.vue";
import mIndex from "@/pages/index.vue";
import Home from "@/views/Home.vue";
import About from "@/views/About.vue";
import News from "@/views/News.vue";
import Career from "@/views/Career.vue";

Vue.use(Router);

const mRoute = [
  {
    path: "/",
    name: "mIndex",
    component: mIndex,
    meta: { title: "首页" },
    children :[
      {
        path: "/",
    name: "home",
    component:() => import("@/pages/home.vue"),
    meta: { title: "首页" },
      },
      {
    path: "/train-cleaning",
    name: "train-cleaning",
    component:() => import("@/pages/TrainCleaning.vue"),
    meta: { title: "列车保洁" },
    children:[
      {
        path: "",
        name: "TrainService",
        component: () => import("@/pages/train/TrainService.vue"),
        meta: { title: "列车保洁" },
      },
      {
        path: "cases",
        name: "CaseList",
        component: () => import("@/pages/train/CaseList.vue"),
        meta: { title: "合作案例" },
      },
      {
        path: "qualifications",
        name: "Qualifications",
        component: () => import("@/pages/train/Qualifications.vue"),
        meta: { title: "公司资质" },
      },
      {
        path: "distribution",
        name: "Distribution",
        component: () => import("@/pages/train/Distribution.vue"),
        meta: { title: "业务分布" },
      },
    ]
  },
  {
    path: "/project-experience",
    name: "project-experience",
    component: () => import("@/pages/ProjectExperience.vue"),
    meta: { title: "项目经验" },
    children:[
       {
        path: "",
        name: "CleaningService",
        component: () => import("@/pages/project/CleaningService.vue"),
        meta: { title: "保洁服务" },
      },
      {
        path: "housekeeping-service",
        name: "HousekeepingService",
        component: () => import("@/pages/project/HousekeepingService.vue"),
        meta: { title: "家政服务" },
      },
      {
        path: "building-service",
        name: "BuildingService",
        component: () => import("@/pages/project/BuildingService.vue"),
        meta: { title: "楼宇服务" },
      },
      {
        path: "other",
        name: "OtherService",
        component: () => import("@/pages/project/OtherService.vue"),
        meta: { title: "其他服务" },
      },
    ]
  },
  {
    path: "/scientific-research",
    name: "scientific-research",
    component: () => import("@/pages/ScientificResearch.vue"),
    meta: { title: "科研革新" },
    children:[
      {
        path: "",
        name: "CleaningEquipment",
        component: () => import("@/pages/scientific/CleaningEquipment.vue"),
        meta: { title: "清洁家具" },
      },
      {
        path: "DisinfestationProducts",
        name: "DisinfestationProducts",
        component: () => import("@/pages/scientific/DisinfestationProducts.vue"),
        meta: { title: "消杀产品" },
      },
      {
        path: "RndSalesIntegration",
        name: "RndSalesIntegration",
        component: () => import("@/pages/scientific/RndSalesIntegration.vue"),
        meta: { title: "研销一体" },
      },
      {
        path: "TechStarRelease",
        name: "TechStarRelease",
        component: () => import("@/pages/scientific/TechStarRelease.vue"),
        meta: { title: "科技新星，重磅发布" },
      },
    ]
  },
  {
    path: "/news",
    name: "news",
    component: () => import("@/pages/News.vue"),
    meta: { title: "新闻中心" },
    children: [
      {
        path: "",
        name: "CompanyNews",
        component: () => import("@/pages/news/CompanyNews.vue"),
        meta: { title: "公司新闻" },
      },
      {
        path: "industry-trends",
        name: "IndustryTrends",
        component: () => import("@/pages/news/IndustryTrends.vue"),
        meta: { title: "行业动态" },
      },
      {
        path: "latest-announcement",
        name: "LatestAnnouncement",
        component: () => import("@/pages/news/LatestAnnouncement.vue"),
        meta: { title: "最新公告" },
      },
      {
        path: "media-attention",
        name: "MediaAttention",
        component: () => import("@/pages/news/MediaAttention.vue"),
        meta: { title: "媒体关注" },
      },
      {
        path: "video-center",
        name: "VideoCenter",
        component: () => import("@/pages/news/VideoCenter.vue"),
        meta: { title: "视频中心" },
      },
      {
        path: "detail1",
        name: "detail1",
        component: () => import("@/pages/news/components/detail1.vue"),
        meta: { title: "detail1" },
      },
       {
        path: "detail2",
        name: "detail2",
        component: () => import("@/pages/news/components/detail2.vue"),
        meta: { title: "detail2" },
      }, {
        path: "detail3",
        name: "detail3",
        component: () => import("@/pages/news/components/detail3.vue"),
        meta: { title: "detail3" },
      }, {
        path: "detail4",
        name: "detail4",
        component: () => import("@/pages/news/components/detail4.vue"),
        meta: { title: "detail4" },
      }, {
        path: "detail5",
        name: "detail5",
        component: () => import("@/pages/news/components/detail5.vue"),
        meta: { title: "detail5" },
      }, {
        path: "detail6",
        name: "detail6",
        component: () => import("@/pages/news/components/detail6.vue"),
        meta: { title: "detail6" },
      }, {
        path: "detail7",
        name: "detail7",
        component: () => import("@/pages/news/components/detail7.vue"),
        meta: { title: "detail7" },
      }, {
        path: "detail8",
        name: "detail8",
        component: () => import("@/pages/news/components/detail8.vue"),
        meta: { title: "detail8" },
      }, {
        path: "detail9",
        name: "detail9",
        component: () => import("@/pages/news/components/detail9.vue"),
        meta: { title: "detail9" },
      }, {
        path: "detail10",
        name: "detail10",
        component: () => import("@/pages/news/components/detail10.vue"),
        meta: { title: "detail10" },
      }, {
        path: "detail11",
        name: "detail11",
        component: () => import("@/pages/news/components/detail11.vue"),
        meta: { title: "detail11" },
      }, {
        path: "detail12",
        name: "detail12",
        component: () => import("@/pages/news/components/detail12.vue"),
        meta: { title: "detail12" },
      }, {
        path: "detail13",
        name: "detail13",
        component: () => import("@/pages/news/components/detail13.vue"),
        meta: { title: "detail13" },
      }, {
        path: "detail14",
        name: "detail14",
        component: () => import("@/pages/news/components/detail14.vue"),
        meta: { title: "detail14" },
      }, {
        path: "detail15",
        name: "detail15",
        component: () => import("@/pages/news/components/detail15.vue"),
        meta: { title: "detail15" },
      }, {
        path: "detail16",
        name: "detail16",
        component: () => import("@/pages/news/components/detail16.vue"),
        meta: { title: "detail16" },
      }, {
        path: "detail17",
        name: "detail17",
        component: () => import("@/pages/news/components/detail17.vue"),
        meta: { title: "detail17" },
      }, {
        path: "detail18",
        name: "detail18",
        component: () => import("@/pages/news/components/detail18.vue"),
        meta: { title: "detail18" },
      }, {
        path: "detail19",
        name: "detail19",
        component: () => import("@/pages/news/components/detail19.vue"),
        meta: { title: "detail19" },
      }, {
        path: "detail20",
        name: "detail20",
        component: () => import("@/pages/news/components/detail20.vue"),
        meta: { title: "detail20" },
      }, {
        path: "detail21",
        name: "detail21",
        component: () => import("@/pages/news/components/detail21.vue"),
        meta: { title: "detail21" },
      }, {
        path: "detail22",
        name: "detail22",
        component: () => import("@/pages/news/components/detail22.vue"),
        meta: { title: "detail22" },
      }, {
        path: "detail23",
        name: "detail23",
        component: () => import("@/pages/news/components/detail23.vue"),
        meta: { title: "detail23" },
      }, {
        path: "detail24",
        name: "detail24",
        component: () => import("@/pages/news/components/detail24.vue"),
        meta: { title: "detail24" },
      }
    ],
  },
  {
    path: "/corporate-culture",
    name: "corporate-culture",
    component: () => import("@/pages/CorporateCulture.vue"),
    meta: { title: "企业文化" },
    children: [
      {
        path: "",
        name: "EmployeeStyle",
        component: () => import("@/pages/corporateCulture/EmployeeStyle.vue"),
        meta: { title: "员工风采" },
      },
      {
        path: "achievements-honor",
        name: "AchievementsHonor",
        component: () => import("@/pages/corporateCulture/AchievementsHonor.vue"),
        meta: { title: "成绩荣誉" },
      },
      {
        path: "other",
        name: "CorporateCultureOther",
        component: () => import("@/pages/corporateCulture/Other.vue"),
        meta: { title: "其他" },
      },
    ],
  },
  {
    path: "/about",
    name: "about",
    component: () => import("@/pages/About.vue"),
    meta: { title: "关于我们" },
     children: [
      {
        path: "",
        name: "CompanyProfile",
        component: () => import("@/pages/aboutMe/CompanyProfile.vue"),
        meta: { title: "公司简介" },
      },
      {
        path: "service-concept",
        name: "ServiceConcept",
        component: () => import("@/pages/aboutMe/ServiceConcept.vue"),
        meta: { title: "服务理念" },
      },
      {
        path: "business-advantages",
        name: "BusinessAdvantages",
        component: () => import("@/pages/aboutMe/BusinessAdvantages.vue"),
        meta: { title: "经营优势" },
      },
      {
        path: "company-scale",
        name: "CompanyScale",
        component: () => import("@/pages/aboutMe/CompanyScale.vue"),
        meta: { title: "公司规模" },
      },
      {
        path: "development-history",
        name: "DevelopmentHistory",
        component: () => import("@/pages/aboutMe/DevelopmentHistory.vue"),
        meta: { title: "光辉历程" },
      },
    ],
  },
  {
    path: "/career",
    name: "career",
    component: () => import("@/pages/Career.vue"),
    meta: { title: "联系我们" },
  },
    ]
  },
  
];

const pcRoute = [
  {
    path: "/",
    name: "pcIndex",
    component: pcIndex,
    meta: { title: "首页" },
    children: [
       {
    path: "/",
    name: "Home",
    component: Home,
    meta: { title: "首页" },
  },
  {
    path: "/about",
    name: "About",
    component: About,
    meta: { title: "关于我们" },
    children: [
      {
        path: "",
        name: "CompanyProfile",
        component: () => import("@/views/aboutMe/CompanyProfile.vue"),
        meta: { title: "公司简介" },
      },
      {
        path: "service-concept",
        name: "ServiceConcept",
        component: () => import("@/views/aboutMe/ServiceConcept.vue"),
        meta: { title: "服务理念" },
      },
      {
        path: "business-advantages",
        name: "BusinessAdvantages",
        component: () => import("@/views/aboutMe/BusinessAdvantages.vue"),
        meta: { title: "经营优势" },
      },
      {
        path: "company-scale",
        name: "CompanyScale",
        component: () => import("@/views/aboutMe/CompanyScale.vue"),
        meta: { title: "公司规模" },
      },
      {
        path: "development-history",
        name: "DevelopmentHistory",
        component: () => import("@/views/aboutMe/DevelopmentHistory.vue"),
        meta: { title: "光辉历程" },
      },
    ],
  },
  {
    path: "/news",
    name: "News",
    component: News,
    meta: { title: "新闻动态" },
    children: [
      {
        path: "",
        name: "CompanyNews",
        component: () => import("@/views/news/CompanyNews.vue"),
        meta: { title: "公司新闻" },
      },
      {
        path: "industry-trends",
        name: "IndustryTrends",
        component: () => import("@/views/news/IndustryTrends.vue"),
        meta: { title: "行业动态" },
      },
      {
        path: "latest-announcement",
        name: "LatestAnnouncement",
        component: () => import("@/views/news/LatestAnnouncement.vue"),
        meta: { title: "最新公告" },
      },
      {
        path: "media-attention",
        name: "MediaAttention",
        component: () => import("@/views/news/MediaAttention.vue"),
        meta: { title: "媒体关注" },
      },
      {
        path: "video-center",
        name: "VideoCenter",
        component: () => import("@/views/news/VideoCenter.vue"),
        meta: { title: "视频中心" },
      },
      {
        path: "detail1",
        name: "detail1",
        component: () => import("@/views/news/components/detail1.vue"),
        meta: { title: "detail1" },
      },
       {
        path: "detail2",
        name: "detail2",
        component: () => import("@/views/news/components/detail2.vue"),
        meta: { title: "detail2" },
      }, {
        path: "detail3",
        name: "detail3",
        component: () => import("@/views/news/components/detail3.vue"),
        meta: { title: "detail3" },
      }, {
        path: "detail4",
        name: "detail4",
        component: () => import("@/views/news/components/detail4.vue"),
        meta: { title: "detail4" },
      }, {
        path: "detail5",
        name: "detail5",
        component: () => import("@/views/news/components/detail5.vue"),
        meta: { title: "detail5" },
      }, {
        path: "detail6",
        name: "detail6",
        component: () => import("@/views/news/components/detail6.vue"),
        meta: { title: "detail6" },
      }, {
        path: "detail7",
        name: "detail7",
        component: () => import("@/views/news/components/detail7.vue"),
        meta: { title: "detail7" },
      }, {
        path: "detail8",
        name: "detail8",
        component: () => import("@/views/news/components/detail8.vue"),
        meta: { title: "detail8" },
      }, {
        path: "detail9",
        name: "detail9",
        component: () => import("@/views/news/components/detail9.vue"),
        meta: { title: "detail9" },
      }, {
        path: "detail10",
        name: "detail10",
        component: () => import("@/views/news/components/detail10.vue"),
        meta: { title: "detail10" },
      }, {
        path: "detail11",
        name: "detail11",
        component: () => import("@/views/news/components/detail11.vue"),
        meta: { title: "detail11" },
      }, {
        path: "detail12",
        name: "detail12",
        component: () => import("@/views/news/components/detail12.vue"),
        meta: { title: "detail12" },
      }, {
        path: "detail13",
        name: "detail13",
        component: () => import("@/views/news/components/detail13.vue"),
        meta: { title: "detail13" },
      }, {
        path: "detail14",
        name: "detail14",
        component: () => import("@/views/news/components/detail14.vue"),
        meta: { title: "detail14" },
      }, {
        path: "detail15",
        name: "detail15",
        component: () => import("@/views/news/components/detail15.vue"),
        meta: { title: "detail15" },
      }, {
        path: "detail16",
        name: "detail16",
        component: () => import("@/views/news/components/detail16.vue"),
        meta: { title: "detail16" },
      }, {
        path: "detail17",
        name: "detail17",
        component: () => import("@/views/news/components/detail17.vue"),
        meta: { title: "detail17" },
      }, {
        path: "detail18",
        name: "detail18",
        component: () => import("@/views/news/components/detail18.vue"),
        meta: { title: "detail18" },
      }, {
        path: "detail19",
        name: "detail19",
        component: () => import("@/views/news/components/detail19.vue"),
        meta: { title: "detail19" },
      }, {
        path: "detail20",
        name: "detail20",
        component: () => import("@/views/news/components/detail20.vue"),
        meta: { title: "detail20" },
      }, {
        path: "detail21",
        name: "detail21",
        component: () => import("@/views/news/components/detail21.vue"),
        meta: { title: "detail21" },
      }, {
        path: "detail22",
        name: "detail22",
        component: () => import("@/views/news/components/detail22.vue"),
        meta: { title: "detail22" },
      }, {
        path: "detail23",
        name: "detail23",
        component: () => import("@/views/news/components/detail23.vue"),
        meta: { title: "detail23" },
      }, {
        path: "detail24",
        name: "detail24",
        component: () => import("@/views/news/components/detail24.vue"),
        meta: { title: "detail24" },
      }
    ],
  },
  {
    path: "/career",
    name: "Career",
    component: Career,
    meta: { title: "加入我们" },
  },
  {
    path: "/train-cleaning",
    name: "TrainCleaning",
    component: () => import("@/views/TrainCleaning.vue"),
    meta: { title: "列车保洁" },
    children: [
      {
        path: "",
        name: "TrainService",
        component: () => import("@/views/train/TrainService.vue"),
        meta: { title: "列车保洁" },
      },
      {
        path: "cases",
        name: "CaseList",
        component: () => import("@/views/train/CaseList.vue"),
        meta: { title: "合作案例" },
      },
      {
        path: "qualifications",
        name: "Qualifications",
        component: () => import("@/views/train/Qualifications.vue"),
        meta: { title: "公司资质" },
      },
      {
        path: "distribution",
        name: "Distribution",
        component: () => import("@/views/train/Distribution.vue"),
        meta: { title: "业务分布" },
      },
    ],
  },
  {
    path: "/project-experience",
    name: "ProjectExperience",
    component: () => import("@/views/ProjectExperience.vue"),
    meta: { title: "项目经验" },
    children: [
      {
        path: "",
        name: "CleaningService",
        component: () => import("@/views/project/CleaningService.vue"),
        meta: { title: "保洁服务" },
      },
      {
        path: "housekeeping-service",
        name: "HousekeepingService",
        component: () => import("@/views/project/HousekeepingService.vue"),
        meta: { title: "家政服务" },
      },
      {
        path: "building-service",
        name: "BuildingService",
        component: () => import("@/views/project/BuildingService.vue"),
        meta: { title: "楼宇服务" },
      },
      {
        path: "other",
        name: "OtherService",
        component: () => import("@/views/project/OtherService.vue"),
        meta: { title: "其他服务" },
      },
    ],
  },
  {
    path: "/scientific-research",
    name: "ScientificResearch",
    component: () => import("@/views/ScientificResearch.vue"),
    meta: { title: "科研革新" },
     children: [
      {
        path: "",
        name: "CleaningEquipment",
        component: () => import("@/views/scientific/CleaningEquipment.vue"),
        meta: { title: "清洁家具" },
      },
      {
        path: "DisinfestationProducts",
        name: "DisinfestationProducts",
        component: () => import("@/views/scientific/DisinfestationProducts.vue"),
        meta: { title: "消杀产品" },
      },
      {
        path: "RndSalesIntegration",
        name: "RndSalesIntegration",
        component: () => import("@/views/scientific/RndSalesIntegration.vue"),
        meta: { title: "研销一体" },
      },
      {
        path: "TechStarRelease",
        name: "TechStarRelease",
        component: () => import("@/views/scientific/TechStarRelease.vue"),
        meta: { title: "科技新星，重磅发布" },
      },
    ],
  },
  {
    path: "/corporate-culture",
    name: "CorporateCulture",
    component: () => import("@/views/CorporateCulture.vue"),
    meta: { title: "企业文化" },
    children: [
      {
        path: "",
        name: "EmployeeStyle",
        component: () => import("@/views/corporateCulture/EmployeeStyle.vue"),
        meta: { title: "员工风采" },
      },
      {
        path: "achievements-honor",
        name: "AchievementsHonor",
        component: () => import("@/views/corporateCulture/AchievementsHonor.vue"),
        meta: { title: "成绩荣誉" },
      },
      {
        path: "other",
        name: "CorporateCultureOther",
        component: () => import("@/views/corporateCulture/Other.vue"),
        meta: { title: "其他" },
      },
    ],
  },
    ]
  },
 
  
];

export const router = new Router({
  mode: "hash",

  // history: createWebHashHistory(),
  // routes:mRoute,
  routes: browserRedirect() == 'PC' ? pcRoute : mRoute,

    scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  },
})
// const router = new Router({
//   routes,
//   scrollBehavior(to, from, savedPosition) {
//     if (savedPosition) {
//       return savedPosition;
//     } else {
//       return { x: 0, y: 0 };
//     }
//   },
// });

export default router;